import { styled } from "styled-components";

export const CancelButton = styled.button`
  background-color: transparent;
  border: none;
  cursor: pointer;
  color: #ccc;
  border: 1px solid #ccc;
  border-radius: 10px;
  height: 100%;
  width: 48%;
  margin-right: 12px;
  font-size: 14px;
`;
